(function(){
  var selector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;

  function openDialog(){
    return document.querySelector('[data-menu-drawer].is-open,[data-cart-drawer].is-open');
  }
  function visibleFocusable(root){
    return Array.prototype.filter.call(root.querySelectorAll(selector), function(el){
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }
  function syncState(){
    var menu = document.querySelector('[data-menu-drawer]');
    var cart = document.querySelector('[data-cart-drawer]');
    var menuButton = document.querySelector('[data-menu-open]');
    var cartButton = document.querySelector('[data-cart-open]');
    var menuOpen = !!(menu && menu.classList.contains('is-open'));
    var cartOpen = !!(cart && cart.classList.contains('is-open'));
    if(menuButton && menu) menuButton.setAttribute('aria-expanded', menuOpen ? 'true' : 'false');
    if(cartButton && cart) cartButton.setAttribute('aria-expanded', cartOpen ? 'true' : 'false');
    document.body.classList.toggle('p47-dialog-open', menuOpen || cartOpen);
  }

  document.addEventListener('click', function(event){
    var trigger = event.target.closest('[data-menu-open],[data-cart-open]');
    if(trigger) lastTrigger = trigger;
    window.setTimeout(function(){
      syncState();
      var dialog = openDialog();
      if(dialog){
        var focusable = visibleFocusable(dialog);
        if(focusable.length && !dialog.contains(document.activeElement)) focusable[0].focus();
      } else if(lastTrigger && document.body.contains(lastTrigger)){
        lastTrigger.focus();
        lastTrigger = null;
      }
    }, 30);
  }, true);

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape'){
      window.setTimeout(function(){
        syncState();
        if(lastTrigger && document.body.contains(lastTrigger)){
          lastTrigger.focus();
          lastTrigger = null;
        }
      }, 0);
      return;
    }
    var dialog = openDialog();
    if(!dialog || event.key !== 'Tab') return;
    var focusable = visibleFocusable(dialog);
    if(!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if(event.shiftKey && document.activeElement === first){
      event.preventDefault();
      last.focus();
    } else if(!event.shiftKey && document.activeElement === last){
      event.preventDefault();
      first.focus();
    }
  });

  var observer = new MutationObserver(syncState);
  ['[data-menu-drawer]','[data-cart-drawer]'].forEach(function(sel){
    var node = document.querySelector(sel);
    if(node) observer.observe(node,{attributes:true,attributeFilter:['class','aria-hidden']});
  });
  syncState();
})();